// Haikal (Mesin Press): pesanan Offline menuju Press yang masih menunggu Rido / Ibnu (status jalur tersimpan, tidak ditebak).
import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useAutoRefresh } from "./use_auto_refresh";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const OFFLINE_WAIT_EVENT = "press-offline-waiting-count";

export function waitReason(x) {
  if (!x.waiting.length) return "Syarat lengkap — menunggu masuk antrean Press";
  const tr = (t) => x.tracks.find(r => r.track === t && !r.done);
  const g = tr("gudang"), sb = tr("sablon");
  const gw = g ? `barang dari ${g.claimed_by || "Rido"} (Gudang)` : "", sw = sb ? `sablon/DTF dari ${sb.claimed_by || "Ibnu"}` : "";
  if (g || sb) return `Belum bisa dikerjakan — menunggu ${[gw, sw].filter(Boolean).join(" dan ")}`;
  return "Belum bisa dikerjakan — belum memenuhi syarat untuk Press";
}

function Item({ x, i, tid, onOpen }) {
  const [open, setOpen] = useState(false);
  return <div className={`press-wait-item${open ? " on" : ""}`} role="button" tabIndex={0} onClick={() => setOpen(v => !v)}
    onKeyDown={(e) => { if (e.target === e.currentTarget && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); setOpen(v => !v); } }}
    aria-expanded={open} data-testid={`${tid}-row-${i}`}>
    <div><b>{x.order_number}</b> · {x.customer_name} · {x.product}{x.variation ? ` (${x.variation})` : ""}{x.qty ? ` · ${x.qty} pcs` : ""}</div>
    <span className="press-wait-why" data-testid={`${tid}-row-${i}-reason`}>{waitReason(x)}</span>
    {open && <dl className="phub-detail" onClick={(e) => e.stopPropagation()} data-testid={`${tid}-row-${i}-detail`}>
      <dt>Status</dt><dd>{x.status || "-"}</dd>
      {x.tracks.map(t => <React.Fragment key={t.track}><dt>{t.team}</dt>
        <dd>{t.done ? `Selesai${t.done_by ? ` · ${t.done_by}` : ""}` : t.claimed_by ? `Dikerjakan ${t.claimed_by}` : "Belum diambil"}</dd></React.Fragment>)}
      {onOpen && <><dt/><dd><button type="button" className="soft-btn small-btn" onClick={() => onOpen(x.order_number)} data-testid={`${tid}-row-${i}-open`}>Buka Nota</button></dd></>}
    </dl>}
  </div>;
}

export function OfflinePressWaiting({ tid = "offline-press-waiting", onOpen }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const load = useCallback(() => axios.get(`${API}/press/offline-waiting`, { withCredentials: true })
    .then(r => { setData(r.data); setErr(""); window.dispatchEvent(new CustomEvent(OFFLINE_WAIT_EVENT, { detail: (r.data?.items || []).length })); })
    .catch(e => setErr(e?.response?.data?.detail || e.message)), []);
  useEffect(() => { load(); }, [load]);
  useAutoRefresh({ enabled: true, intervalMs: 30_000, onRefresh: load });
  useEffect(() => {
    window.addEventListener("press-queue-changed", load);
    return () => window.removeEventListener("press-queue-changed", load);
  }, [load]);
  if (!data && !err) return <div className="muted small" data-testid={tid}>Memuat…</div>;
  const items = data?.items || [];
  return <div data-testid={tid}>
    {err && <div className="warn-box small" data-testid={`${tid}-error`}>{err}</div>}
    {!err && items.length === 0 && <div className="muted small" data-testid={`${tid}-empty`}>Tidak ada pekerjaan Offline yang menunggu divisi sebelumnya.</div>}
    <div className="press-wait-list">{items.map((x, i) => <Item key={`${x.order_number}-${x.product_id}`} x={x} i={i} tid={tid} onOpen={onOpen}/>)}</div>
  </div>;
}

export function useOfflineWaitCount() {
  const [c, setC] = useState(null);
  useEffect(() => {
    let alive = true;
    axios.get(`${API}/press/offline-waiting`, { withCredentials: true }).then(r => alive && setC((r.data?.items || []).length)).catch(() => {});
    const h = (e) => setC(e.detail);
    window.addEventListener(OFFLINE_WAIT_EVENT, h);
    const r = () => axios.get(`${API}/press/offline-waiting`, { withCredentials: true }).then(x => setC((x.data?.items || []).length)).catch(() => {});
    window.addEventListener("press-queue-changed", r);
    return () => { alive = false; window.removeEventListener(OFFLINE_WAIT_EVENT, h); window.removeEventListener("press-queue-changed", r); };
  }, []);
  return c;
}

export default OfflinePressWaiting;
